<template>
  <div :class="holderClass">
    <UlSelect
      v-model="$v.insuranceCompany.$model"
      :disabled="disabled"
      :error="$v.insuranceCompany.$error"
      :error-message="
        $v.insuranceCompany.$error ? $t('questionForm.insuranceCompany.errorText') : undefined
      "
      :hint="messages"
      :label="insuranceTitle"
      :options="options"
      :placeholder="placeholderText"
      hide-details="auto"
      @focus="sendGtmEvent('Pojišťovna')"
    >
      <template #optionTitle="{ item }">
        {{ getLocaleText(item.value) }}
      </template>
      <template #selection="{ item }">
        <div class="text-truncate">
          {{ getLocaleText(item.value) }}
        </div>
      </template>
    </UlSelect>
  </div>
</template>

<script>
import { required as requiredValidation } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import formValidation from '@/mixins/formValidation';
import sortableValues from '@/mixins/sortableValues';
import formGtm from '@/mixins/formGtm';

export default {
  name: 'InsuranceCompany',
  mixins: [formValidation, formGtm, sortableValues],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    holderClass: {
      type: String,
      default: 'mb-4'
    },
    messages: {
      type: String,
      default: null
    },
    placeholder: {
      type: Number,
      required: false
    },
    required: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      required: false
    }
  },
  validations() {
    if (this.required) {
      return {
        insuranceCompany: { requiredValidation }
      };
    }
    return {
      insuranceCompany: {}
    };
  },
  computed: {
    options() {
      const sortedValues = this.sortValues(this.insuranceCompanyList);

      const csInsurance = sortedValues.filter(val => val.additionalInfo.countryCode === 'CZ');
      const skInsurance = sortedValues.filter(val => val.additionalInfo.countryCode === 'SK');

      return this.$domainRegion === 'cz' ? sortedValues : skInsurance.concat(csInsurance);
    },
    placeholderText() {
      if (this.placeholder) {
        let insuranceCompany = this.insuranceCompanyList.find(val => val.id === this.placeholder);
        if (insuranceCompany) {
          return (
            (insuranceCompany.code ? insuranceCompany.code : '') +
            ' ' +
            (insuranceCompany.code
              ? ` - ${insuranceCompany.abbr} (${insuranceCompany.name})`
              : insuranceCompany.name)
          );
        }
      } else {
        return this.$t('questionForm.insuranceCompany.selectInsuranceCompany');
      }
      return '';
    },
    insuranceTitle() {
      return this.title || this.$t('questionForm.insuranceCompany.title');
    },
    ...mapGetters({
      insuranceCompanyList: 'forms/insuranceCompany/insuranceCompanyList'
    }),
    insuranceCompany: {
      get() {
        return this.$store.state.forms.insuranceCompany.insuranceCompany;
      },
      set(value) {
        this.$store.commit('forms/insuranceCompany/updateInsuranceCompany', value);
      }
    }
  },
  created() {
    this.loadInsuranceCompanyList({
      region: this.$domainRegion
    });
    if (this.value !== undefined) {
      this.insuranceCompany = this.value;
    }

    this.$eventHub.$on('validateInsuranceCompany', done =>
      this.validateForm(done, 'forms/insuranceCompany')
    );
  },
  beforeDestroy() {
    this.$eventHub.$off('validateInsuranceCompany');
  },
  methods: {
    ...mapActions({
      loadInsuranceCompanyList: 'forms/insuranceCompany/loadInsuranceCompanyList'
    })
  }
};
</script>
